import { Link, useLocation } from "react-router-dom";
import { useLegal } from "@/lib/legalApi";

const HIDDEN_PREFIXES = ["/admin", "/editor", "/personalizar", "/dashboard", "/login", "/register", "/forgot-password", "/reset-password"];

export const LEGAL_LINKS = [
  { slug: "termos", label: "Termos e Condições" },
  { slug: "privacidade", label: "Privacidade" },
  { slug: "cookies", label: "Cookies" },
  { slug: "devolucoes", label: "Envios e Devoluções" },
];

/** Barra legal global (rodapé) — obrigatória para lojas online em Portugal. */
export default function SiteLegalBar() {
  const { pathname } = useLocation();
  const legal = useLegal();
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;
  const company = legal?.company_name ? `${legal.company_name}${legal.nif ? ` · NIF ${legal.nif}` : ""}` : null;
  return (
    <div className="bg-[#09090B] border-t border-[#222225] text-xs text-[#8B8B93]" data-testid="site-legal-bar">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-5 flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
        <nav className="flex flex-wrap gap-x-5 gap-y-2">
          {LEGAL_LINKS.map((l) => (
            <Link key={l.slug} to={`/legal/${l.slug}`} className="hover:text-white transition-colors" data-testid={`legal-link-${l.slug}`}>
              {l.label}
            </Link>
          ))}
          <a
            href={legal?.livro_url || "https://www.livroreclamacoes.pt/Inicio/"}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
            data-testid="legal-link-livro"
          >
            Livro de Reclamações
          </a>
        </nav>
        <div className="md:text-right">
          {company && <span data-testid="legal-company">{company} · </span>}© {new Date().getFullYear()} {legal?.trade_name || "KROMA"}
        </div>
      </div>
    </div>
  );
}
